import { Template } from '../../interfaces';

export const templates: Template[] = [
    {
        id: '1',
        nombre: 'Plantilla QM',
        idUsuario: '1',
        mapping: {
            primerFilaDatos: '3',
            ultimaColDatos: '',
            clienteCodigo: '0',
            clienteRazon: '1',
            telefono: '7',
            email: '8',
            fechaPedido: '10',
            pedidoOpMapeo: '11',
            latitud: '',
            longitud: '',
            codPedido: '9',
            codProducto: '12',
            descProducto: '13',
            cantProducto: '14',
            peso: '15',
            volumen: '16',
            dinero: '17',
            demoraDuracion: '18',
            horarioAm: '19',
            horarioPm: '20',
            comentario: '21',
            agrupacion: '22',
            merchantEmailList: '23',
            habilidades: '26',
            abasto: '24',
            marca: '',
            codigoPostal: '',
            codPedidoAutogenerar: false,
            pedidoOpFijar: true,
            pedidoOp: 'E',
            clienteCodigoAutogenerar: false,
            clienteCodigoTrim: false,
            fechaPedidoAutogenerar: false,
            demoraDuracionFijar: false,
            demoraDuracionDefault: '',
            direccion: '2,3,4',
            direccion2: '',
            vehiculo: '',
            vehiculoDireccion: '',
            fechaFormato: 'DD/MM/AAAA',
            ungroup: '27',
            ordenEntrega: '28',
            retornable: '29',
            promocion: '30',
            ordenEntregaFormato: 'DD-MM HH:mm',
            bultos: '31',
            pallet: '32',
        },
        defecto: true,
        qm: false,
    },
    // Template with errors
    {
        id: '2',
        nombre: 'Avanzado con errores y algo más',
        idUsuario: '1',
        mapping: {
            primerFilaDatos: '3',
            ultimaColDatos: '',
            clienteCodigo: '0',
            clienteRazon: '21',
            telefono: '7',
            email: '8',
            fechaPedido: '10',
            pedidoOpMapeo: '11',
            latitud: '',
            longitud: '',
            codPedido: '20', // Target to an empty field of the file
            codProducto: '12',
            descProducto: '13',
            cantProducto: '14',
            peso: '15',
            volumen: '16',
            dinero: '17',
            demoraDuracion: '',
            horarioAm: '19',
            horarioPm: '20',
            comentario: '21',
            agrupacion: '22',
            merchantEmailList: '23',
            habilidades: '26',
            abasto: '24',
            marca: '',
            codigoPostal: '',
            codPedidoAutogenerar: false,
            pedidoOpFijar: false,
            pedidoOp: '',
            clienteCodigoAutogenerar: false,
            clienteCodigoTrim: false,
            fechaPedidoAutogenerar: false,
            demoraDuracionFijar: true,
            demoraDuracionDefault: '', // shouldn't be empty
            direccion: '', // shouldn't be empty
            direccion2: '',
            vehiculo: '',
            vehiculoDireccion: '',
            fechaFormato: 'DD/MM/AAAA',
            ungroup: '27',
            ordenEntrega: '28',
            retornable: '29',
            promocion: '30',
            ordenEntregaFormato: 'DD-MM HH:mm',
            bultos: '31',
            pallet: '32',
        },
        defecto: false,
        qm: false,
    },
    {
        id: '3',
        nombre: 'Avanzado con errores',
        idUsuario: '1',
        mapping: {
            primerFilaDatos: '3',
            ultimaColDatos: '',
            clienteCodigo: '0',
            clienteRazon: '21',
            telefono: '7',
            email: '8',
            fechaPedido: '10',
            pedidoOpMapeo: '11',
            latitud: '',
            longitud: '',
            codPedido: '20', // Target to an empty field of the file
            codProducto: '12',
            descProducto: '13',
            cantProducto: '14',
            peso: '15',
            volumen: '16',
            dinero: '17',
            demoraDuracion: '',
            horarioAm: '19',
            horarioPm: '20',
            comentario: '21',
            agrupacion: '22',
            merchantEmailList: '23',
            habilidades: '26',
            abasto: '24',
            marca: '',
            codigoPostal: '',
            codPedidoAutogenerar: false,
            pedidoOpFijar: false,
            pedidoOp: '',
            clienteCodigoAutogenerar: false,
            clienteCodigoTrim: false,
            fechaPedidoAutogenerar: false,
            demoraDuracionFijar: true,
            demoraDuracionDefault: '', // shouldn't be empty
            direccion: '', // shouldn't be empty
            direccion2: '',
            vehiculo: '',
            vehiculoDireccion: '',
            fechaFormato: 'DD/MM/AAAA',
            ungroup: '27',
            ordenEntrega: '28',
            retornable: '29',
            promocion: '30',
            ordenEntregaFormato: 'DD-MM HH:mm',
            bultos: '31',
            pallet: '32',
        },
        defecto: false,
        qm: false,
    },
    {
        id: '4',
        nombre: 'Template 4',
        idUsuario: '1',
        mapping: {
            primerFilaDatos: '3',
            ultimaColDatos: '',
            clienteCodigo: '0',
            clienteRazon: '21',
            telefono: '7',
            email: '8',
            fechaPedido: '10',
            pedidoOpMapeo: '11',
            latitud: '',
            longitud: '',
            codPedido: '20', // Target to an empty field of the file
            codProducto: '12',
            descProducto: '13',
            cantProducto: '14',
            peso: '15',
            volumen: '16',
            dinero: '17',
            demoraDuracion: '',
            horarioAm: '19',
            horarioPm: '20',
            comentario: '21',
            agrupacion: '22',
            merchantEmailList: '23',
            habilidades: '26',
            abasto: '24',
            marca: '',
            codigoPostal: '',
            codPedidoAutogenerar: false,
            pedidoOpFijar: false,
            pedidoOp: '',
            clienteCodigoAutogenerar: false,
            clienteCodigoTrim: false,
            fechaPedidoAutogenerar: false,
            demoraDuracionFijar: true,
            demoraDuracionDefault: '', // shouldn't be empty
            direccion: '', // shouldn't be empty
            direccion2: '',
            vehiculo: '',
            vehiculoDireccion: '',
            fechaFormato: 'DD/MM/AAAA',
            ungroup: '27',
            ordenEntrega: '28',
            retornable: '29',
            promocion: '30',
            ordenEntregaFormato: 'DD-MM HH:mm',
            bultos: '31',
            pallet: '32',
        },
        defecto: false,
        qm: false,
    },
    {
        id: '5',
        nombre: 'Template 5 con nombre largo',
        idUsuario: '1',
        mapping: {
            primerFilaDatos: '3',
            ultimaColDatos: '',
            clienteCodigo: '0',
            clienteRazon: '21',
            telefono: '7',
            email: '8',
            fechaPedido: '10',
            pedidoOpMapeo: '11',
            latitud: '',
            longitud: '',
            codPedido: '20', // Target to an empty field of the file
            codProducto: '12',
            descProducto: '13',
            cantProducto: '14',
            peso: '15',
            volumen: '16',
            dinero: '17',
            demoraDuracion: '',
            horarioAm: '19',
            horarioPm: '20',
            comentario: '21',
            agrupacion: '22',
            merchantEmailList: '23',
            habilidades: '26',
            abasto: '24',
            marca: '',
            codigoPostal: '',
            codPedidoAutogenerar: false,
            pedidoOpFijar: false,
            pedidoOp: '',
            clienteCodigoAutogenerar: false,
            clienteCodigoTrim: false,
            fechaPedidoAutogenerar: false,
            demoraDuracionFijar: true,
            demoraDuracionDefault: '', // shouldn't be empty
            direccion: '', // shouldn't be empty
            direccion2: '',
            vehiculo: '',
            vehiculoDireccion: '',
            fechaFormato: 'DD/MM/AAAA',
            ungroup: '27',
            ordenEntrega: '28',
            retornable: '29',
            promocion: '30',
            ordenEntregaFormato: 'DD-MM HH:mm',
            bultos: '31',
            pallet: '32',
        },
        defecto: false,
        qm: false,
    },
];
